import type { JSX } from 'react';
import type {
  BiomarkerSelection,
  IBiomarkerData,
  IChartLaneLogScale,
} from '@/types/PatientDashboard/PatientTimeline.types';
import BiomarkerLaneBody from './BiomarkerLaneBody';
import Section from './Section';

interface IProps {
  data: IBiomarkerData;
  selection: BiomarkerSelection;
  isLoading: boolean;
  hasFailure: boolean;
  isOpen: boolean;
  onToggle: () => void;
  onToggleVariant: (variantId: string) => void;
  onRetry: () => void;
  scale: IChartLaneLogScale;
  xPct: (date: string) => number;
}

export default function BiomarkerPanel({
  data,
  selection,
  isLoading,
  hasFailure,
  isOpen,
  onToggle,
  onToggleVariant,
  onRetry,
  scale,
  xPct,
}: IProps): JSX.Element {
  return (
    <Section
      title="Biomarker"
      count={data.lines.length}
      isLoading={isLoading}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <BiomarkerLaneBody
        data={data}
        isLoading={isLoading}
        hasFailure={hasFailure}
        selection={selection}
        onToggle={onToggleVariant}
        onRetry={onRetry}
        scale={scale}
        xPct={xPct}
      />
    </Section>
  );
}
